var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { applyStyles, applyClass, any } from './utils';
import Drawer from './drawer';
var Tools = /** @class */ (function (_super) {
    __extends(Tools, _super);
    function Tools(component, mezzanine) {
        var _this = _super.call(this, component, 'tools') || this;
        _this.mezzanine = mezzanine;
        return _this;
    }
    Tools.prototype.isHidden = function () {
        return this.component.toolsHide;
    };
    Tools.prototype.isOpen = function () {
        return this.component.toolsOpen;
    };
    Tools.prototype.getWidth = function (isMobile) {
        return this.component.toolsOpen ? this.component.toolsWidth : this.getToggleDesktopWidth(isMobile);
    };
    Tools.prototype.getDrawerStyles = function (isMobile) {
        if (isMobile) {
            return {
                width: window.innerWidth,
                top: this.mezzanine.getVisibleHeaderHeight(),
                right: this.isOpen() ? 0 : -window.innerWidth
            };
        }
        return {
            width: this.component.toolsWidth,
            marginRight: this.isOpen() ? 0 : -this.component.toolsWidth + this.getToggleDesktopWidth(isMobile)
        };
    };
    Tools.prototype.update = function (isMobile) {
        return any([
            applyClass(this.drawer, 'awsui-app-layout--open', this.isOpen()),
            applyClass(this.drawer, 'awsui-app-layout__utils--hide', this.component.toolsHide),
            applyStyles(this.drawer, this.getDrawerStyles(isMobile))
        ]);
    };
    return Tools;
}(Drawer));
export default Tools;
//# sourceMappingURL=tools.js.map